module.exports = __webpack_public_path__ + "static/media/Engage Play Tools_green.c3f49822.svg";